const state = () => ({
  fomoUsersTableStats: [],
  paginationFomo: {
    sortBy: "desc",
    descending: false,
    page: 1,
    rowsPerPage: 50,
    rowsNumber: null
  }
});

const getters = {};

const actions = {};

const mutations = {
  updateFomoUsersTableStats(state, val) {
    state.fomoUsersTableStats = val.userStats;
  },

  updatePaginationFomo(state, val) {
    state.paginationFomo.rowsPerPage = val.size;
    state.paginationFomo.rowsNumber = val.count;
  },

  updatePaginationPageFomo(state, val) {
    state.paginationFomo.sortBy = val.sortBy;
    state.paginationFomo.descending = val.descending;
    state.paginationFomo.page = val.page;
  },
  updatePaginationPageCustomersFomo(state, val) {
    state.paginationFomo.sortBy = val.sortBy;
    state.paginationFomo.descending = val.descending;
    state.paginationFomo.page = val.page;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
